import {SocialType} from '../domain/Social';

export const socials = Object.values(SocialType).filter(
  (type) => type !== SocialType.EMAIL && type !== SocialType.PHONE
) as Exclude<SocialType, SocialType.EMAIL>[];

export const isSocial = (type: string | undefined) =>
  Object.values(SocialType).includes(type as SocialType);
